import { render } from "./UnitInfo_content_base.vue?vue&type=template&id=41f32c72"
import script from "./UnitInfo_content_base.vue?vue&type=script&lang=js"
export * from "./UnitInfo_content_base.vue?vue&type=script&lang=js"

import "./UnitInfo_content_base.vue?vue&type=style&index=0&id=41f32c72&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__